// Mock data for Coin Espace Vert website

export const companyInfo = {
  name: "Coin Espace Vert",
  phone: "06 63 53 81 29",
  email: "Coin.espacevert@gmail.com",
  address: "Hérault (34) et alentours",
  logo: "https://customer-assets.emergentagent.com/job_961d97c6-50e4-46e3-91b3-16f8e9a09cf5/artifacts/qb2witqo_file-WNfXHwXxU8Bt1R68DSTbf3.webp"
};

export const services = [
  {
    id: 1,
    title: "Tonte de Pelouse",
    description: "Entretien régulier de votre pelouse pour un gazon impeccable toute l'année.",
    icon: "Scissors",
    image: "https://images.unsplash.com/photo-1683316924890-6a8c5ab10d29"
  },
  {
    id: 2,
    title: "Taille de Haies et Arbustes",
    description: "Taille professionnelle de vos haies et arbustes pour un jardin soigné.",
    icon: "TreeDeciduous",
    image: "https://images.unsplash.com/photo-1605117882932-f9e32b03fea9"
  },
  {
    id: 3,
    title: "Création et Aménagement",
    description: "Conception et réalisation de jardins sur mesure selon vos envies.",
    icon: "Flower2",
    image: "https://images.unsplash.com/photo-1597201278257-3687be27d954"
  },
  {
    id: 4,
    title: "Entretien d'Espaces Verts",
    description: "Maintenance complète de vos espaces verts pour les garder en parfait état.",
    icon: "Sprout",
    image: "https://images.unsplash.com/photo-1734079692160-fcbe4be6ab96"
  },
  {
    id: 5,
    title: "Élagage d'Arbres",
    description: "Élagage professionnel et sécurisé de vos arbres par des experts qualifiés.",
    icon: "TreePine",
    image: "https://images.unsplash.com/photo-1758524052292-38f3ec63b572"
  },
  {
    id: 6,
    title: "Désherbage et Nettoyage",
    description: "Élimination des mauvaises herbes et nettoyage complet de vos espaces.",
    icon: "Leaf",
    image: "https://images.unsplash.com/photo-1758524052320-cc60db187fe3"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dubois",
    location: "Montpellier",
    rating: 5,
    text: "Service impeccable ! Mon jardin n'a jamais été aussi beau. L'équipe est professionnelle et à l'écoute.",
    date: "Il y a 2 semaines"
  },
  {
    id: 2,
    name: "Jean-Pierre Martin",
    location: "Béziers",
    rating: 5,
    text: "Je recommande vivement ! Travail soigné et prix très correct. Mon gazon est parfait depuis qu'ils s'en occupent.",
    date: "Il y a 1 mois"
  },
  {
    id: 3,
    name: "Sophie Laurent",
    location: "Sète",
    rating: 5,
    text: "Excellent travail d'élagage. Rapides, efficaces et très professionnels. Je ferai à nouveau appel à eux.",
    date: "Il y a 3 semaines"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1668120089662-42642838cfef",
    title: "Entretien de pelouse",
    category: "Tonte"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/230629/pexels-photo-230629.jpeg",
    title: "Aménagement paysager",
    category: "Création"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/33917299/pexels-photo-33917299.jpeg",
    title: "Jardin fleuri",
    category: "Entretien"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1629308804040-5f664f933d4a",
    title: "Taille de haies",
    category: "Taille"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1597201278257-3687be27d954",
    title: "Massif de fleurs",
    category: "Aménagement"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1683316924890-6a8c5ab10d29",
    title: "Tonte professionnelle",
    category: "Tonte"
  }
];

export const aboutContent = {
  title: "À Propos de Coin Espace Vert",
  description: "Spécialistes de l'entretien et de l'aménagement d'espaces verts dans l'Hérault, nous mettons notre expertise au service de vos jardins depuis plusieurs années.",
  values: [
    {
      title: "Professionnalisme",
      description: "Une équipe qualifiée et expérimentée à votre service"
    },
    {
      title: "Qualité",
      description: "Un travail soigné avec des résultats durables"
    },
    {
      title: "Proximité",
      description: "Un service local et personnalisé dans tout le département"
    }
  ]
};
